import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, TableSkeleton } from "@/components/shared";
import { money, label } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from "recharts";

const COLORS = ["#255058", "#d9a441", "#2f9e5f", "#3b7fd4", "#8b5cf6", "#c65a63"];

export default function Reports() {
  const [d, setD] = useState(null);

  useEffect(() => { api.get("/dashboard/command-center").then(({ data }) => setD(data)).catch(() => setD({})); }, []);
  if (!d) return <div><PageHeader title="Reports" subtitle="Loading…" /><TableSkeleton /></div>;

  const stage = (d.pipeline_by_stage || []).map((s) => ({ name: label(s.stage), count: s.count }));
  const region = d.regional_performance || [];
  const lb = d.leaderboard || [];

  return (
    <div className="space-y-6">
      <PageHeader title="Reports & Analytics" subtitle="Executive analytics — computed from live records" />
      <div className="grid md:grid-cols-3 gap-4">
        {Object.entries(d.conversions || {}).map(([k, v]) => (
          <Card key={k} className="p-5"><div className="text-xs text-muted-foreground">{label(k)}</div><div className="font-display text-3xl font-bold mt-1">{v}%</div></Card>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <Card className="p-5">
          <div className="font-display font-semibold mb-4">Pipeline Stage Aging</div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={stage} margin={{ left: -20 }}>
              <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} angle={-35} textAnchor="end" height={70} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
              <Tooltip contentStyle={{ borderRadius: 12, fontSize: 12 }} />
              <Bar dataKey="count" radius={[6, 6, 0, 0]}>{stage.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Bar>
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card className="p-5">
          <div className="font-display font-semibold mb-4">Regional Performance</div>
          <div className="space-y-3">
            {region.map((r, i) => (
              <div key={i} className="flex items-center justify-between py-1.5 border-b border-border/50 last:border-0">
                <span className="font-medium">{r.region}</span>
                <div className="text-right"><div className="font-semibold">{money(r.revenue)}</div><div className="text-xs text-muted-foreground">{r.placements} placements</div></div>
              </div>
            ))}
            {!region.length && <div className="text-sm text-muted-foreground">No regional data</div>}
          </div>
        </Card>
      </div>
      <Card className="p-5">
        <div className="font-display font-semibold mb-4">Recruiter Performance</div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {lb.map((r, i) => (
            <div key={i} className="p-4 rounded-lg border border-border"><div className="text-sm font-medium truncate">{r.recruiter}</div><div className="font-display text-2xl font-bold mt-1">{r.submissions}</div><div className="text-xs text-muted-foreground">submissions</div></div>
          ))}
          {!lb.length && <div className="text-sm text-muted-foreground">No data</div>}
        </div>
      </Card>
    </div>
  );
}
